<div class="dialog-content">
  <app-reset-password-form
    [code]="code"
    (resetPasswordFormSubmit)="resetPasswordFormSubmit()"
    (backClick)="backClick()"
  ></app-reset-password-form>
</div>
